import FavoritesList from "./FavoritesList";
export default FavoritesList;
